<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid class="no-padding full">
    <ion-row>
      <ion-col
        size-sm="6"
        offset-sm="3"
        class="ion-margin-horizontal"
      >
        <ion-item lines="none">
          <ion-img
            class="logo"
            [src]="logo"
          ></ion-img>
        </ion-item>

        <form
          [formGroup]="loginAsForm"
          (ngSubmit)="isPermalinkFormSubmitted = true; loginAs()"
          [class.submitted]="isPermalinkFormSubmitted"
        >
          <mable-input
            label="Permalink"
            class="margin"
          >
            <ion-input
              aria-label="Permalink"
              type="text"
              formControlName="permalink"
            ></ion-input>
            <div class="warn">
              <p *ngIf="loginAsForm.controls.permalink.errors?.required">Permalink can't be blank</p>
            </div>
          </mable-input>

          <mable-button
            buttonType="submit"
            expand="block"
            >Login as</mable-button
          >
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
